var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container logo-component col-12 w-100"},[_c('router-link',{attrs:{"tag":"a","to":"/"}},[_c('div',{staticClass:"logo-text",style:(_vm.logoStyle),domProps:{"innerHTML":_vm._s(_vm.title_text_show)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }